import { createSlice } from "@reduxjs/toolkit";
import { UserInfo } from "@app/types";

interface userState {
  value: UserInfo;
}

const initialState = {
  value: {},
} as userState;

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { setUser } = userSlice.actions;

export default userSlice.reducer;
